import Analytics from './analytics';
import Monitoring from './monitoring';

class Performance {
  static measurements = new Map();
  
  // Start measuring performance
  static startMeasurement(name) {
    this.measurements.set(name, performance.now());
  }
  
  // End measurement and report
  static endMeasurement(name, category = 'performance') {
    const startTime = this.measurements.get(name);
    if (!startTime) return;
    
    const duration = performance.now() - startTime;
    this.measurements.delete(name);
    
    // Report to analytics
    Analytics.trackTiming(category, name, Math.round(duration));
    
    // Add breadcrumb for monitoring
    Monitoring.addBreadcrumb(`Performance: ${name}`, 'performance', 'info', {
      duration: Math.round(duration),
      category
    });
    
    return duration;
  }
  
  // Measure component load time
  static measureComponentLoad(componentName) {
    return {
      start: () => this.startMeasurement(`${componentName}_load`),
      end: () => this.endMeasurement(`${componentName}_load`, 'component_load')
    };
  }
  
  // Measure API call performance
  static measureApiCall(apiName) {
    return {
      start: () => this.startMeasurement(`api_${apiName}`),
      end: () => this.endMeasurement(`api_${apiName}`, 'api_performance')
    };
  }
  
  // Measure user interaction response time
  static measureInteraction(interactionName) {
    return {
      start: () => this.startMeasurement(`interaction_${interactionName}`),
      end: () => this.endMeasurement(`interaction_${interactionName}`, 'user_interaction')
    };
  }
  
  // Report Web Vitals
  static reportWebVitals(metric) {
    Analytics.trackEvent('web_vital', 'performance', metric.name, Math.round(metric.value));
    
    // Log poor performance as warning
    if (metric.rating === 'poor') {
      Monitoring.logMessage(`Poor ${metric.name}: ${metric.value}`, 'warning', {
        metric: metric.name,
        value: metric.value,
        rating: metric.rating
      });
    }
  }
  
  // Monitor memory usage (if supported)
  static checkMemoryUsage() {
    if ('memory' in performance) {
      const memory = performance.memory;
      const memoryUsage = {
        used: Math.round(memory.usedJSHeapSize / 1048576), // MB
        total: Math.round(memory.totalJSHeapSize / 1048576), // MB
        limit: Math.round(memory.jsHeapSizeLimit / 1048576) // MB
      };
      
      Analytics.trackEvent('memory_usage', 'performance', 'memory_check', memoryUsage.used);
      
      // Warn if memory usage is high
      if (memoryUsage.used > memoryUsage.limit * 0.8) {
        Monitoring.logMessage('High memory usage detected', 'warning', memoryUsage);
      }
      
      return memoryUsage;
    }
    return null;
  }
}

export default Performance; 